module.exports = __webpack_public_path__ + "static/media/26UNRWA7.0721ff24.jpg";